import React from 'react';

const SvgPlus = (props) => (
  <svg width="1em" height="1em" viewBox="-2 -1 15 14" {...props}>
    <path
      fill="currentColor"
      d="M5.963 0C2.67 0 0 2.686 0 6s2.67 6 5.963 6c3.294 0 5.963-2.686 5.963-6s-2.67-6-5.963-6zm2.385 6.6H6.56v1.8H5.367V6.6h-1.79V5.4h1.79V3.6H6.56v1.8h1.788v1.2z"
    />
  </svg>
);

export default SvgPlus;
